import { render, staticRenderFns } from "./EditMode.vue?vue&type=template&id=6f0cf4fc&scoped=true"
import script from "./EditMode.vue?vue&type=script&lang=js"
export * from "./EditMode.vue?vue&type=script&lang=js"
import style0 from "./EditMode.vue?vue&type=style&index=0&id=6f0cf4fc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f0cf4fc",
  null
  
)

export default component.exports